import { Container, Typography, Paper } from "@material-ui/core";

export default function CookiePolicy() {
  return (
    <Container maxWidth="sm">
      <Paper style={{ padding: 20, marginTop: 20 }}>
        <Typography variant="h5">Cookiepolitik</Typography>

        <Typography style={{ marginTop: 12 }}>
          Vi bruger cookies for at få login og siden til at fungere.
        </Typography>

        <Typography style={{ marginTop: 12 }}>
          Ved brug af siden accepterer du brug af nødvendige cookies.
        </Typography>

        <Typography style={{ marginTop: 12 }}>
          Du kan slette cookies i din browser.
        </Typography>

        <Typography style={{ marginTop: 12 }}>
          Kontakt: nbitecodeteam@gmail.com
        </Typography>
      </Paper>
    </Container>
  );
}